module.exports = __webpack_public_path__ + "media/images/mobile/abouts/20-548660aa8d5776f10078484a3fe2c234.png";